module.exports = __webpack_public_path__ + "static/img/noData.11990286.png";